//配置路由的相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../views/Home.vue'
// import HomeChat from '../components/homeChat.vue'
import Login from '../views/Login.vue'
import Index1 from '../views/index1.vue'
import Setting from '../views/settings.vue'
import Index from '../views/index.vue'
import SetPassword from '../views/SetPassword.vue'
import Operations from '../views/operationManager.vue'

//个人设置页面
import Forget from '../views/personsetting/ForgetPassword.vue'
import Message from '../views/personsetting/MyMessage.vue'
import Invite from '../views/personsetting/Invite.vue'
import Quick from '../views/personsetting/Quick.vue'
import Parameter from '../views/personsetting/Parameter.vue'

//系统设置页面
// import oplog from '../views/systemsetting/oplog.vue'
// import leavemsg from '../views/systemsetting/leavemsg.vue'
import Authority from '../views/systemsetting/Authority.vue'
import TalkRule from '../views/systemsetting/TalkRule.vue'
import TagManager from '../views/systemsetting/TagManager.vue'
import WindowStyle from '../views/systemsetting/WindowStyle.vue'
import DialogWindow from '../views/systemsetting/DialogWindow.vue'
import BlackManager from '../views/systemsetting/BlackManager.vue'
import ConfigParams from '../views/systemsetting/ConfigParams.vue'

import LogManager from '../views/systemsetting/LogManager.vue'
import Leavemsg from '../views/systemsetting/MsgManager.vue'
// import MsgManager from '../views/systemsetting/MsgManager.vue'
import Oplog from '../views/systemsetting/LoggingManager.vue'
// import LoggingManager from '../views/systemsetting/LoggingManager.vue'
import NightWork from '../views/systemsetting/NightWork.vue'
import speechCraft from '../views/systemsetting/speechCraft.vue'
import hospitalInfo from '../views/systemsetting/hospitalInfo.vue'
import adUserId from '../views/systemsetting/AdUserId.vue'
import loginrecordlist from '../views/loginmg/loginrecordlist.vue'
import equipmentlist from '../views/loginmg/equipmentlist.vue'
import equmglist from '../views/loginmg/equmglist.vue'

//middleman设置界面
import RuleSet from '../views/midmansetting/ruleset.vue'
import RobotSet from '../views/midmansetting/robotset.vue'
import MonitorSet from '../views/midmansetting/monitorset.vue'
import OperationCsfeedback from '../views/midmansetting/csfeedback.vue'
import OperationCsOptions from '../views/midmansetting/csOptions.vue'
import OperationRobotreply from '../views/midmansetting/robotreply.vue'

import ModeOptions from '../views/midmansetting/modeOptions.vue'

import Corpus from '../views/robotsetting/corpus.vue'
import Edit from '../views/robotsetting/edit.vue'
import Estimate from '../views/robotsetting/estimate.vue'
import Model from '../views/robotsetting/model.vue'
import Indeterminate from '../views/robotsetting/indeterminate.vue'
import TestRobot from '../views/robotsetting/testRobot.vue'
import simpleModel from '../views/robotsetting/simpleModel.vue'
import Multimodeutter from '../views/systemsetting/Multimodeutter.vue'

import ChatReport from '../views/chatReport.vue'
import SessionReportNew from '../views/sessionReportNew.vue'

import LoginLog from '../views/loginLog.vue'

// 运维管理页面
import OperationSpeechCraft from '../views/opereation/speechCraft.vue'
import OperationRobotset from '../views/opereation/robotset.vue'
import OperationRuleset from '../views/opereation/ruleset.vue'


const isElectron = navigator.userAgent.toLowerCase().indexOf("electron/") !== -1;
//1.通过Vue.use(插件)安装插件
Vue.use(VueRouter)

//2.创建VueRouter对象
const router = new VueRouter({
	//配置路由和组件之间的映射关系
	// mode: 'history',
	mode: isElectron ? 'hash' : 'history',
	// mode: 'hash',
	routes: [
		{
			path: '/',
			name: 'index',
			component: Index,
			meta: {
				title: '客服登录'
			}
		},
		{
			path: '/index1',
			name: 'index1',
			component: Index1,
			meta: {
				title: '客服登录'
			}
		},
		{
			path: '/Login',
			name: 'login',
			component: Login,
			meta: {
				title: '客服登录'
			}
		},
		{
			path: '/SetPassword',
			name: 'setpassword',
			component: SetPassword,
			meta: {
				title: '修改密码'
			}
		},
		{
			path: '/home',
			name: 'home',
			component: Home,
			meta: {
				title: '智能客服',
			}
		},
		{
			path: '/session-report-new',
			name: 'sessionReportNew',
			component: SessionReportNew,
			meta: {
				title: '会话统计-新版',
			}
		},
		{
			path: '/setting',
			name: 'setting',
			component: Setting,
			meta: {
				title: '客服设置'
			},
			children: [
				{
					path: 'leavemsg',
					name: 'leavemsg',
					component: Leavemsg,
					meta: {
						title: '留言管理'
					}
				},
				{
					path: 'params',
					name: 'params',
					component: ConfigParams,
					meta: {
						title: '系统参数配置'
					}
				},
				{
					path: 'oplog',
					name: 'oplog',
					component: Oplog,
					meta: {
						title: '操作日志'
					}
				},
				{
					path: 'mymessage',
					name: 'MyMessage',
					component: Message,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'forgetpassword',
					name: 'ForgetPassword',
					component: Forget,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'invite',
					name: 'Invite',
					component: Invite,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'quick',
					name: 'Quick',
					component: Quick,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'parameter',
					name: 'Parameter',
					component: Parameter,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'authority',
					name: 'Authority',
					component: Authority,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'talkrule',
					name: 'TalkRule',
					component: TalkRule,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'tagmanager',
					name: 'TagManager',
					component: TagManager,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'windowstyle',
					name: 'WindowStyle',
					component: WindowStyle,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'dialogwindow',
					name: 'DialogWindow',
					component: DialogWindow,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'blackmanager',
					name: 'BlackManager',
					component: BlackManager,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'logmanager',
					name: 'LogManager',
					component: LogManager,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'nightwork',
					name: 'NightWork',
					component: NightWork,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'aduser',
					name: 'aduser',
					component: adUserId,
					meta: {
						title: '推广账号管理'
					}
				},
				{
					path: 'speechcraft',
					name: 'speechCraft',
					component: speechCraft,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'hospitalInfo',
					name: 'hospitalInfo',
					component: hospitalInfo,
					meta: {
						title: '医院信息管理'
					}
				},
				{
					path: 'ruleset',
					name: 'RuleSet',
					component: RuleSet,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'robotset',
					name: 'RobotSet',
					component: RobotSet,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'monitorset',
					name: 'MonitorSet',
					component: MonitorSet,
					meta: {
						title: '客服设置'
					}
				},
				{
					path: 'corpus',
					name: 'Corpus',
					component: Corpus,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'edit',
					name: 'Edit',
					component: Edit,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'estimate',
					name: 'Estimate',
					component: Estimate,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'model',
					name: 'Model',
					component: Model,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'indeterminate',
					name: 'Indeterminate',
					component: Indeterminate,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'testrobot',
					name: 'TestRobot',
					component: TestRobot,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'simplemodel',
					name: 'simpleModel',
					component: simpleModel,
					meta: {
						title: '机器人设置'
					}
				},
				{
					path: 'Multimodeutter',
					name: 'Multimodeutter',
					component: Multimodeutter,
					meta: {
						title: '机器人设置'
					}
				},
			]
		},
		{
			path: '/loginmg',
			name: 'loginmg',
			component: Setting,
			meta: {
				title: '登录管理'
			},
			children: [
				{
					path: 'loginrecordlist',
					name: 'loginrecordlist',
					component: loginrecordlist,
					meta: {
						title: '登录管理'
					}
				},
				{
					path: 'equipmentlist',
					name: 'equipmentlist',
					component: equipmentlist,
					meta: {
						title: '登录管理'
					}
				},
				{
					path: 'equmglist',
					name: 'equmglist',
					component: equmglist,
					meta: {
						title: '登录管理'
					}
				}
			]
		},
		// {
		// 	path: 'loggingmanager',
		// 	name: 'LoggingManager',
		// 	component: LoggingManager,
		// 	meta: {
		// 		title: '日志查看'
		// 	}
		// },
		// {
		// 	path: '/msgmanager',
		// 	name: 'MsgManager',
		// 	component: MsgManager,
		// 	meta: {
		// 		title: '留言管理'
		// 	}
		// },
		{
			path: '/loginlog',
			name: 'LoginLog',
			component: LoginLog,
			meta: {
				title: '登录日志'
			}
		},
		{
			path: '/chatreport',
			name: 'ChatReport',
			component: ChatReport,
			meta: {
				title: '聊天历史记录'
			}
		},
		{
			path: '/operations',
			name: 'operations',
			component: Operations,
			meta: {
				title: '运维管理'
			},
			children: [
				{
					path: '/',
					name: '/',
					component: OperationSpeechCraft,
					meta: {
						title: '自定义话术'
					}
				},
				{
					path: 'speechCraft',
					name: 'speechCraft',
					component: OperationSpeechCraft,
					meta: {
						title: '自定义话术'
					}
				},
				{
					path: 'robotset',
					name: 'robotset',
					component: OperationRobotset,
					meta: {
						title: '科室引擎配置'
					}
				},
				{
					path: 'ruleset',
					name: 'ruleset',
					component: OperationRuleset,
					meta: {
						title: '科室规则配置'
					}
				},
				{
					path: 'csfeedback',
					name: 'csfeedback',
					component: OperationCsfeedback,
					meta: {
						title: '对话反馈'
					}
				},
				{
					path: 'csOptions',
					name: 'csOptions',
					component: OperationCsOptions,
					meta: {
						title: '参数配置'
					}
				},
				{
					path: 'modeOptions',
					name: 'modeOptions',
					component:ModeOptions,
					meta: {
						title: '模式配置'
					}
				},

				{
					path: 'robotreply',
					name: 'robotreply',
					component: OperationRobotreply,
					meta: {
						title: '机器人接待设置'
					}
				}
			]
		},

	]
})


//3.将router对象传入到vue实例
export default router